/// <reference path="../../lib/app.d.ts" />

import {TemplateEngine} from "../lib/template-engine";

export class FixedBottom {

	private disabled : boolean = true;
	private config : any;

	private rollingTimer: number;
	private rollingPause: boolean = false;

	private templateEngine : TemplateEngine;

	private chatSize : string = "";
	private chatRatio : string = "";

	constructor() {
		this.templateEngine = new TemplateEngine();

		this.getConfig();
	}

	////////////////////////////////////////////////////////////////////////

	public setChatSize(_chatSize: string) {
		this.chatSize = _chatSize;

		$('.sxcc-fixed-bottom').removeClass('size-normal').removeClass('size-fb').removeClass('size-fs').addClass('size-'+this.chatSize);

		if(this.chatSize == 'fs') {
			$('.sxcc-fixed-bottom-handler').css({'background': '#ffdd65'});

			$('.sxcc-fixed-bottom').css({'padding-top': ''});
			$('.sxcc-fixed-bottom-handler').removeClass('small').addClass('full');

			setTimeout(() => { $('.sxcc-fixed-bottom-handler').css({'background': 'transparent'}); }, 15000);
		} else {
			$('.sxcc-fixed-bottom-handler').css({'background': '#21ace4'});

			$('.sxcc-fixed-bottom').css({'padding-top': '20px'});
			$('.sxcc-fixed-bottom-handler').removeClass('full').addClass('small');
		}

		if(this.chatSize == 'fb' || this.chatRatio != '169') {
			$('.sxcc-fixed-bottom').hide();
			$('.sxcc-fixed-bottom-handler').hide();
		} else {
			$('.sxcc-fixed-bottom').show();
			$('.sxcc-fixed-bottom-handler').show();
		}

		//if(this.chatSize == 'normal') { this.openFixedBottom(true); } else { this.closeFixedBottom(true); }
	}

	public setChatRatio(_ratioId: string) {
		this.chatRatio = _ratioId;
	}

	////////////////////////////////////////////////////////////////////////

	private getConfig() {
		$.ajax({
			url: 'https://sexchat.hu/config/fixedBottom',
			dataType: "jsonp",
			crossDomain: true,
			success: (json) => { this.onGetConfigSuccess(json); this.bindDOMEvents(); }
		});
	}

	private onGetConfigSuccess(json: Object) {
		this.config = json;

		this.closeFixedBottom(true);  // Lecsukja a megjelenítést (inaktív állapotra)
		this.showDomIfActive();       // Megjeleníti az alsó részt, ha aktív
		this.startRoolingTimer();     // Forgató (roller) indítása

		$(window).on("resize", () => {
			let maxWindowHeight = (($('.sxc-chat').hasClass('sxcc-ratio-43')) ? 800 : 630);

			if($(window).height() <= maxWindowHeight) {
				$('.sxcc-fixed-bottom').hide();
				$('.sxcc-fixed-bottom-handler').hide();
			} else if(this.chatSize != '' && this.chatSize == 'fb') {
				$('.sxcc-fixed-bottom').hide();
				$('.sxcc-fixed-bottom-handler').hide();
			} else if(this.chatRatio != '' && this.chatRatio != '169') {
				$('.sxcc-fixed-bottom').hide();
				$('.sxcc-fixed-bottom-handler').hide();
			} else {
				$('.sxcc-fixed-bottom').show();
				$('.sxcc-fixed-bottom-handler').show();
			}
		});
	}

	private bindDOMEvents() {
		$('.sxcc-fixed-bottom, .sxcc-fixed-bottom-handler').mouseenter(() => {
			this.rollingPause = true;

			this.openFixedBottom();
		});
		$('.sxcc-fixed-bottom, .sxcc-fixed-bottom-handler').mouseleave(() => {
			this.rollingPause = false;

			this.closeFixedBottom();
		});
	}

	////////////////////////////////////////////////////////////////////////

	private showDomIfActive() {
		if (this.config.active === false) { return; }

		let layoutDOM : JQuery = this.templateEngine.render("fixed-bottom-tpl-"+this.config.layout);
		$('.sxcc-fixed-bottom').empty().append(layoutDOM).addClass('column-'+this.config.column).show();  // Modul megjelenítése
		$('.sxcc-fixed-bottom-handler').show();

		this.tickRollingTimer();  // Első rolling betöltése

		this.disabled = false;  // Modul engedélyezése
	}

	////////////////////////////////////////////////////////////////////////

	private startRoolingTimer() {
		if (this.config.rolltime == -1 || this.disabled === true) { return; }

		this.rollingTimer = setInterval(() => {
			this.tickRollingTimer();
		}, this.config.rolltime);
	}

	private tickRollingTimer() {
		if(this.rollingPause === true) { return; }

		//console.log('rolling');

		this.rollingPanel();
	}

	private stopRoolingTimer() {
		clearInterval(this.rollingTimer);
	}

	////////////////////////////////////////////////////////////////////////

	private rollingPanel() {
		$.each(this.config.panels, (panelId, panelData) => {
			if(panelData.rolling === false) { return true; }

			//console.log(panelData);
			this.changePanelContent(panelId, panelData);
		});
	}

	private changePanelContent(panelId: number, panelData: any) {
		let moduleListKeys  = Object.keys(panelData.module);
		let moduleListKey   = moduleListKeys[ moduleListKeys.length * Math.random() << 0 ];
		let moduleListValue = panelData.module[ moduleListKey ];

		let moduleKeys  = Object.keys(moduleListValue);
		let moduleKey   = moduleKeys[ moduleKeys.length * Math.random() << 0 ];
		let moduleValue = moduleListValue[ moduleKey ];

		let moduleDOM : JQuery;
		let tplName : string;

		switch(moduleKey) {
			case 'register': { moduleDOM = this.templateEngine.render("fixed-bottom-"+moduleKey); break; }
			case 'gift': {
				let moduleData = moduleValue.split(":");
				if(moduleValue == '_open') {
					moduleDOM = this.templateEngine.render("fixed-bottom-gift-open");
				} else {
					moduleDOM = this.templateEngine.render("fixed-bottom-gift-item", { gift_name: moduleData[0], gift_price: moduleData[1], nice_name: moduleData[2] });
				}
				break;
			}
		}

		$('.sxcc-fixed-body.panel-' + (panelId + 1)).empty().append(moduleDOM).data('current', moduleKey);
	}

	////////////////////////////////////////////////////////////////////////

	private openFixedBottom(_force: boolean = false) {
		//if(this.chatSize == 'normal' && _force === false) { return; }

		$('.sxcc-fixed-bottom').addClass('active');

		if(this.chatSize == 'fs') {
			$('.sxcc-fixed-bottom-handler').addClass('active');
		}
	}
	private closeFixedBottom(_force: boolean = false) {
		//if(this.chatSize == 'normal' && _force === false) { return; }

		$('.sxcc-fixed-bottom, .sxcc-fixed-bottom-handler').removeClass('active');
	}
}
